import { Injectable, Injector, OnInit } from '@angular/core';
import { SettingModel } from '../models/setting.model';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { ApiInterface, ApiService } from '../../api/api.service';
import { Collection } from '../../support/collection/collection';
import { ApiCollection } from './../../api/collection';

@Injectable()
export class SettingService extends ApiService implements ApiInterface, OnInit {

    public restEndpoint = 'settings';

    public model = SettingModel;

    public settings: ApiCollection = new ApiCollection();

    public mapped = {};

    public groups = [];

    public fetched: ReplaySubject<any> = new ReplaySubject();

    protected cache = true;

    protected localCache = true;

    protected cacheExpire = 300;

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(injector: Injector) {
        super(injector);

        this.fetched.subscribe((settings) => {
            this.settings = settings;
            this.mapped   = this.map(settings);
        });

        this.onLogout();
    }

    /**
     * OnInit.
     */
    ngOnInit() {
    }

    /**
     * Load all settings from the database
     * -> should only run once on startup
     *
     * @returns {Observable|"../../Observable".Observable|"../../../Observable".Observable}
     */
    public init() {

        return new Observable(observer => {
            this.all().subscribe((settings) => {
                this.fetched.next(settings);
                observer.next(true);
            }, (error) => {
                observer.next(false);
                // this.fetched.error(error);
                observer.error('Something went wrong while fetching the settings from the database');
            });
        });

    }

    public map(collection: Collection) {
        return collection.mapWithKeys((item) => {
            const value = item.files.length ? item.files[0].value : item.value;

            return {
                key: item['name'],
                value: value,
            };
        });
    }

    /**
     * Get a setting.
     *
     * @param name
     * @param callback
     * @param defaultValue
     */
    public get(name: string | Array<string>, callback?, defaultValue?: any): any {

        if (callback) {
            this.fetched.subscribe((settings) => {

                let value;

                // check if name is an array
                // -> if so, return an object with setting keys specified
                if (name instanceof Array) {

                    value = {};

                    name.forEach(settingName => {
                        if (this.mapped && this.mapped[settingName]) {
                            value[settingName] = this.mapped[settingName];
                        }
                    });

                } else {

                    if (this.mapped && this.mapped[name]) {
                        value = this.mapped[name];
                    } else {
                        value = defaultValue;
                    }

                }

                return callback(value);
            });
        }

        return new Observable(observer => {

            this.fetched.subscribe((settings) => {

                let value;

                // check if name is an array
                // -> if so, return an object with setting keys specified
                if (name instanceof Array) {

                    value = {};

                    name.forEach(settingName => {
                        if (this.mapped && this.mapped[settingName]) {
                            value[settingName] = this.mapped[settingName];
                        }
                    });

                } else {

                    if (this.mapped && this.mapped[name]) {
                        value = this.mapped[name];
                    } else {
                        value = defaultValue;
                    }

                }

                observer.next(value);
                observer.complete();
            });

        });
    }

    protected onLogout() {
        // remove cached data on logout (when subject completes)
        this.authService.user().subscribe(null, null, () => {
            this.resetCache();

            // re-subscribe
            setTimeout(() => {
                this.onLogout();
            }, 500);
        });
    }

    /**
     * Get a item by the given name.
     *
     * @param name
     * @param array
     */
    private getItem(name: string, array: any[]) {
        return array.find(item => item.name === name);
    }

    /**
     * Check if the group exists by the given name.
     *
     * @param name
     * @param array
     * @returns {boolean}
     */
    private exists(name: string) {
        return !!this.mapped[name];
    }

    /**
     * Save the settings.
     */
    public save(data) {
        return new Promise((resolve, reject) => {
            this.custom('put', this.getEndpointUrl() + '/form', data, null, true).subscribe((settings) => {
                this.fetched.next(settings);
                resolve(settings);
            }, (error) => {
                reject(error);
            });
        });
    }

}





// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/settings/services/setting.service.ts